import TypoGraphyKit from "@/shared/components/kit/typoGraphy";
import { Grid } from "@mui/material";
import ContentCards from "./content.cards";
/**
 * Content
 *
 * کامپوننتی برای نمایش بخش مشتریان سازمانی.
 * این کامپوننت شامل:
 * - توضیحات و مقدمه برای کاربر در بالای صفحه
 * - نمایش لیست کارت‌های سازمان‌ها با استفاده از کامپوننت ContentCards
 * - استفاده از Grid برای ساختار واکنش‌گرا
 *
 * @returns JSX.Element
 */
const Content = () => {
  return (
    <Grid container>
      <Grid size={12} sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "start",
        gap: 1,
        mb: 3
      }}>
        <TypoGraphyKit variant="body1">مشتریان سازمانی</TypoGraphyKit>
        <TypoGraphyKit variant="body1">پذیرنده گرامی ؛</TypoGraphyKit>
        <TypoGraphyKit variant="body1" sx={{textAlign:"right",marginBottom:"20px"}}>
          در این بخش لیست سازمانهای ثبت شده توسط شما وجود دارد. شما میتوانید
          لیست تراکنش های کاربران سازمان ها از فروشگاه خود را مشاهده نمایید و
          اعتبار مشتریان را در فروشگاه خود افزایش یا کاهش دهید.
        </TypoGraphyKit>
      </Grid>
      <Grid size={{xs:12}}>
        <ContentCards />
      </Grid>
    </Grid>
  );
};

export default Content;